// This app's shared browser-history singleton, used outside React (e.g. an
// axios interceptor redirecting on 401) and passed into
// <BrowserRouter history={history}> in App.js.
//
// Deliberately NOT named "history.js": this project's jsconfig.json sets
// compilerOptions.baseUrl to "src" (for CRA-style absolute imports like
// `configs/app.config`), and Vite's vite-tsconfig-paths plugin resolves any
// bare specifier that matches a path under baseUrl before falling through to
// node_modules. The literal string 'history' matched "src/history.js"
// itself, so `import { createBrowserHistory } from 'history'` inside that
// file resolved to itself -- a circular self-import. That produced
// "history.createBrowserHistory is not a function", and after switching to
// a named import, "The requested module '/src/history.js' does not provide
// an export named 'createBrowserHistory'". Living under a name that can't
// collide with the npm package `history` sidesteps this entirely.
import { createBrowserHistory } from 'history'

export default createBrowserHistory()
